// i18n area 'vms' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/vms.sr-Latn-RS.meta.json.
import type { enUS } from './vms'

export const srLatnRS: typeof enUS = {
  vms: {
    spof: {
      title: 'Nezavisnost od čvora',
      single: 'Jedinstvena tačka otkaza',
      alternativesNow: 'Alternative sada',
      structural: 'Po konstrukciji',
      binding: 'Obavezujuće ograničenje',
      movableNow: 'Migracija moguća sada',
    },
    title: 'Virtuelne mašine',
    migratingChip: 'Migracija u toku',
    templateChip: 'Šablon',
    expendableTooltip: 'U degradiranom klasteru među prvima pada i možda se neće ponovo pokrenuti posle gubitka čvora.',
    expendableHaTooltip: 'Uvek se restartuje dok je klaster zdrav; u degradiranom klasteru zaštićene VM imaju prednost — može biti zaustavljena ili ostati ugašena dok klaster ponovo ne bude ceo, a onda se sama vraća.',
    viewDetails: 'Prikaži detalje',
    profileLegacy: 'Drugi OS',
    hugePagesNone: 'Nijedna — obična memorija',
    hugePages2M: 'Stranice od 2 MiB',
    hugePages1G: 'Stranice od 1 GiB',
    searchPlaceholder: 'Pretraži po imenu',
    name: 'Ime',

    // Terminologia UNA (#94a): la phase si chiama 'Fase' ovunque — la
    // vecchia chiave 'state' è morta col polish della lista.
    vcpus: 'vCPU',
    memory: 'Memorija',
    ipAddresses: 'IP adrese',
    noIp: 'Nema IP adrese',
    authorityNode: 'Authority',
    authorityNextStart: 'dodeljuje se pri sledećem pokretanju',
    scope: 'Scope',
    empty: 'Nema virtuelnih mašina',
    loadError: 'Nije moguće učitati virtuelne mašine — da li je TVirt backend dostupan?',
    filterOverlay: 'overlay mreža',
    filterDisk: 'disk',
    filterImage: 'slika',
    filteredBy: 'Filtrirano po: {kind}',
    filterPhase: 'Faza',
    filterProtection: 'Zaštita',
    filterAll: 'Sve',
    filterScopePlaceholder: 'Filtrirajte po scopeu',
    filtersToggle: 'Filteri',
    scopeTree: {
      title: 'Scope',
      all: 'Ceo klaster',
      noChildren: 'Ovde nema pod-scopeova',
      recursive: 'Uključi potomke',
      collapse: 'Skupi panel scopeova',
      up: 'Jedan nivo naviše',
      countTooltip: 'VM-ova u ovom scopeu: {direct} · sa potomcima: {total}'
    },

    // Il picker ISO a due passi (#85): prima il catalogo, poi le sue ISO.
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Van vidljivih kataloga',
      noIsos: 'Nema spremnih ISO slika u ovom katalogu'
    },
    actionsHeader: 'Akcije',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardver',
      tags: 'Tagovi',
      age: 'Starost',
      disk: 'disk',
      disks: 'diskova',
      empty: 'Još nema šablona — označite ugašenu VM kao šablon, ili klonirajte VM kao šablon.',
      clone: 'Kloniraj / deploy',
      editTags: 'Izmeni tagove',

      // Round K3 (#64): esporta il template come file .tvtpl del catalogo.
      exportAction: 'Izvezi u katalog (.tvtpl)',
      exportTitle: 'Izvezite u katalog',
      exportSubmit: 'Izvezi',
      exportError: 'Izvoz nije uspeo',
      exportHint: 'Šablon se pakuje u .tvtpl arhivu (hardverski manifest + svaki disk izravnat u qcow2) kao nova Template VM datoteka u izabranom katalogu. NIC-ovi, CD/DVD mediji i cloud-init ne putuju — spec formata navodi svako namerno izostavljanje.',
      exportName: 'Ime datoteke',
      exportNameHint: 'Prazno = <template>-export-<n>',
      exportStorageDefault: 'Storage metapodataka šablona',

      // Importa da catalogo (Luca 2026-08-03): l'ingresso in toolbar del tab
      // Template — il backend K3/K4 copre tutti i formati vm-template, la
      // scelta è il FILE (il formato viaggia in sola lettura).
      importAction: 'Uvezi iz kataloga',
      importTitle: 'Uvezite iz kataloga',
      importHint: 'Template VM datoteka u stanju ready iz izabranog kataloga postaje šablon inventara: format datoteke (tvtpl, ova, ovf ili goli qcow2) sam odlučuje kako se uvozi — vi birate samo datoteku.',
      importFile: 'Datoteka kataloga',
      importFileHint: 'Uvoze se samo datoteke u stanju ready — datoteka usred otpremanja nije uvoziva',
      importNoFiles: 'U ovom katalogu nema Template VM datoteka u stanju ready — prvo otpremite ili izvezite jednu'
    },
    templateDetail: {
      quickDeploy: 'Kompatibilnost sa QuickDeploy',
      quickDeployNone: 'Nije deklarisana',
      quickDeployHint: 'Deklarišite je samo ako golden slika sadrži cloud-init (Linux) ili cloudbase-init nakon sysprep /generalize (Windows): platforma veruje deklaraciji i nikada ne gleda unutar gosta.',
      notFound: 'Šablon nije pronađen',
      frozen: 'Hardverska konfiguracija je zamrznuta: konvertujte šablon nazad u VM da biste je izmenili. Ime, beleške i tagovi ostaju izmenjivi.',
      storage: 'Storage',
      size: 'Veličina',
      configTitle: 'Konfiguracija (zamrznuta)',
      usbClasses: 'Zahtevane USB klase',
      gpuClasses: 'Zahtevane GPU klase'
    },
    sharedDisksTab: {
      title: 'Deljeni diskovi',
      sharing: 'Deljenje',
      sharingNone: 'Jedno priključenje',
      sharingMultiwriter: 'Deljeno pisanje (multiwriter)',
      sharingReadonly: 'Deljeno samo za čitanje',
      usedBy: 'Koristi',
      attachedTo: 'Priključen na',
      notAttached: 'Nije priključen ni na jednu VM',
      changeSharing: 'Promeni režim deljenja',
      changeSharingTitle: 'Režim deljenja',
      changeSharingLocked: 'Režim se menja samo dok nijedna VM ne koristi disk',
      sharingChanged: 'Režim deljenja ažuriran.',
      lun: 'Ceo LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serijski broj',
      antiAffinityWarning: 'Dva ili više članova rade na istom čvoru bez pravila anti-afiniteta: otkaz jednog čvora obara ih sve',
      antiAffinityCreate: 'Napravi pravilo',
      createSourceLun: 'Preuzmi ceo LUN targeta',
      createLunNumber: 'Broj LUN-a (id namespace-a na NVMe)',
      createLunHint: 'Ništa se ne dodeljuje: veličina se očitava sa uređaja pri preuzimanju',
      noPr: 'U ovom izdanju nema SCSI-3 persistent reservations: Windows Failover Cluster sa klasičnim deljenim diskom nije validiran; klasteri koji se koordiniraju mrežom (GFS2/OCFS2, RHEL HA, shared-disk baze) jesu'
    },
    unusedDisksTab: {
      title: 'Nekorišćeni diskovi',
      attach: 'Prikači na VM',
      attachTitle: 'Prikačite na VM',
      vm: 'Virtuelna mašina',
      noVms: 'Nema dostupnih VM-ova',
      noSlots: 'Nema slobodnih slotova na ovoj VM',

      // Crea disco standalone (#87): tornato dall'Inventario pensionato, ora
      // con campo scope ESPLICITO (non c'è una VM da cui ereditare).
      create: 'Kreiraj disk',
      createTitle: 'Kreirajte disk',
      createSourceBlank: 'Prazan disk',
      createSourceImage: 'Iz slike u katalogu',
      createImage: 'Slika',
      createImageEmpty: 'Nema spremne slike VM šablona u vidljivim katalozima',
      createSizeFromImageHint: 'Unapred popunjeno virtuelnom veličinom slike — može samo da raste',

      // #107 (DISTRUTTIVO, ratificato): qcow2 → catalog file vm-template
      // sullo stesso storage, zero byte copiati — il disco cessa di esistere.
      convert: 'Konvertuj u VM šablon…',
      convertOnlyQcow2: 'Konvertuju se samo qcow2 diskovi — raw nije format šablona koji se može registrovati',
      convertTitle: 'Konvertujte u VM šablon',
      convertSubmit: 'Konvertuj (uništava disk)',
      convertError: 'Nije moguće pokrenuti konverziju',
      convertWarning: 'DESTRUKTIVNO: disk postaje datoteka VM šablona u izabranom katalogu — isti storage, nula kopiranih bajtova — i PRESTAJE DA POSTOJI kao disk. Povratka nema, osim kreiranjem novog diska iz šablona.',
      convertNameHint: 'Ime datoteke kataloga — podrazumevano ime samog diska',
      convertConfirm: 'Razumem: disk će biti uništen',
      convertStarted: 'Konverzija je pokrenuta — šablon se pojavljuje u katalogu po završetku zadatka.',
      storageLockHint: 'Storage se menja samo akcijom Premesti',
      source: 'Poreklo',
      sourceClone: 'Klon drugog diska',
      sourceCloneLinked: 'Linked clone drugog diska',
      sourceImage: 'Kreiran iz slike',
      sourceBlank: 'Kreiran prazan',
      allocated: 'Alocirano / virtuelna veličina',
      observedAt: 'Posmatrano',
      snapshots: 'Snimci',
      snapshotsEmpty: 'Nema snimaka'
    },
    phase: {
      defined: 'Nikad upaljena',
      starting: 'Pokreće se',
      running: 'U toku',
      stopping: 'Zaustavlja se',
      stopped: 'Ugašena',
      paused: 'Pauzirana',
      failed: 'U grešci',
      deleting: 'Briše se'
    },
    stopCause: {
      'api': 'Zaustavio ju je TVirt (akcija ili API)',
      'guest-shutdown': 'Shutdown pokrenut iz guest operativnog sistema',
      'crash': 'Crash guesta',
      'qemu-exit': 'QEMU proces se neočekivano završio',
      'host-reboot': 'Čvor je restartovan',
      'migrated': 'Migrirana na drugi čvor',
      'fenced': 'Prekinuta HA fencingom (čvor se vratio)'
    },
    detail: {
      notFound: 'Virtuelna mašina nije pronađena',
      details: 'Detalji',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardverski profil',
      firmware: 'Firmware',
      firmwareFile: 'UEFI firmware verzija',
      firmwareUpdate: 'Dostupno ažuriranje',
      firmwareUpdateHint: 'Platforma isporučuje noviji UEFI firmware. Ažuriranje nikad nije automatsko: primenjuje se dok je VM ugašena, kad vi odlučite.',
      arch: 'Arhitektura',
      node: 'Čvor',
      bootOrder: 'Redosled pokretanja',
      agent: 'Status agenta',
      agentConnected: 'Povezan',
      agentNotConnected: 'Nije povezan',
      protected: 'Zaštićena',
      linkedClones: 'Povezani klonovi',
      restartPolicy: 'Politika restartovanja',
      preferredNode: 'Željeni čvor',
      noPreference: 'Bez preferencije (automatski placement)',
      preferNodes: 'Željeni tagovi čvorova',
      requireNodes: 'Obavezni tagovi čvorova',
      noPlacementTags: 'Nijedna',
      placementTag: 'Tag',
      placementValue: 'Vrednost',
      placementAddTag: 'Dodaj tag',
      proximityHa: 'TVirt Proximity HA',
      proximityHaRestarts: 'HA restartovanja',
      proximityHaGaveUp: 'crash loop — HA je odustao',
      failoverProtection: 'Zaštita pri degradaciji',
      protectionProtected: 'Zaštićena',
      protectionExpendable: 'Potrošna pri degradaciji',
      protectionInherit: 'Nasleđuje',
      lastStop: 'Poslednje zaustavljanje',
      yes: 'Da',
      no: 'Ne',
      tabOverview: 'Pregled',
      tabSnapshots: 'Snimci',
      tabBackups: 'Kopije',
      hardware: 'Hardver',
      name: 'Ime',
      hwSystem: 'Sistem',
      hwCpu: 'CPU',
      hwMemory: 'Memorija',
      hwBoot: 'Pokretanje',
      hwIdentity: 'Identitet',
      hwCluster: 'Klaster i agent',
      cpuTopology: 'CPU topologija',
      cpuModel: 'CPU model',
      cpuLimit: 'CPU limit',
      cpuWeight: 'CPU težina',
      cpuNested: "Ugnežđena virtuelizacija",
      cpuNestedHint: "Izlaže vmx/svm gostu (samo sa CPU modelom host). Na upaljenoj VM izmena važi od sledećeg power cycle-a (PendingRestart); raspoređivanje dozvoljava samo čvorove sa uključenim nested.",
      unlimited: 'Neograničeno',
      memory: 'Memorija',
      balloon: 'Balloon',
      hugePages: 'Ogromne stranice',
      hugePagesTradeoff: 'Manje posla oko prevođenja adresa i memorija koja nikad ne odlazi na disk; zauzvrat rezervacija ostaje zaključana na čvoru dok je VM upaljena, memorija se više ne deduplikuje, a pokretanje ne uspeva ako čvor nema dovoljno slobodnih stranica.',
      disks: 'Diskovi',
      cdroms: 'CD/DVD uređaji',
      nics: 'Mrežni interfejsi',
      slot: 'Slot',
      disk: 'Disk',
      encrypted: 'Šifrovan',
      image: 'Slika',
      emptyDrive: 'Prazan uređaj',
      emptyOption: '(prazno)',
      network: 'Mreža',
      mac: 'MAC',
      connected: 'Povezan',
      unplugged: 'Otkačen',
      noDevices: 'Nijedan',
      screenshot: 'Snimak ekrana',
      capturedAt: 'Snimljeno u',
      noCapture: 'Još nema snimka ekrana',
      snapshotName: 'Ime',
      snapshotCreated: 'Kreiran',
      snapshotMemory: 'Memorija uključena',
      noSnapshots: 'Nema snimaka',
      pendingRestart: 'Izmene na čekanju: primeniće se pri sledećem power cycleu.',
      applied: 'primenjeno',
      appliedHint: 'VM trenutno radi sa ovom vrednošću — konfigurisana vrednost se primenjuje pri sledećem power cycleu.',
      actionError: 'Akcija nije uspela',
      actionStillRunning: 'Akcija je još u toku: ishod još nije poznat',
      tabConsole: 'Konzola',
      consoleConnect: 'Poveži',
      consoleDisconnect: 'Prekini vezu',
      consoleConnecting: 'Povezivanje…',
      consoleReconnecting: 'Povezivanje…',
      consoleUnavailable: 'Konzola je dostupna dok VM radi ili je pauzirana.',
      consoleError: 'Povezivanje na konzolu nije uspelo',
      consoleTaken: 'Konzolnu sesiju je preuzeo {user}',
      consoleReconnect: 'Poveži ponovo',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Držite pritisnuto {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Otvori preko celog ekrana u novom tabu',
      consoleLoadFailed: 'VM nije pronađena ili su dozvole nedovoljne',
      consoleClose: 'Zatvori',
      tabStats: 'Statistika',
      tabTasks: 'Zadaci',
      tabLogs: 'Logovi',
      statsCpu: 'CPU',
      statsMemory: 'Memorija',
      statsDisk: 'I/O diska',
      statsRange: 'Interval',
      statsNoData: 'Nema podataka u intervalu — statistika se uzorkuje dok VM radi.',
      statsError: 'Nije moguće učitati statistiku',
      cpuUsage: 'Iskorišćenost',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Iskorišćena',
      memGuestAvailable: 'Dostupna (guest)',
      schema: 'Šema',
      consoleProtocol: 'Konzola',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Storage metapodataka',
      startupOnBoot: 'Pokretanje pri bootu',
      startupOrder: 'Redosled starta',
      startupDelay: 'Odlaganje starta',
      seconds: 's',
      enabled: 'Omogućeno',
      disabled: 'Onemogućeno'
    },
    actionsAvailable: 'Dostupne akcije',
    actions: {
      start: 'Pokreni',
      stop: 'Zaustavi',
      pause: 'Pauziraj',
      resume: 'Nastavi',
      reset: 'Resetuj',
      migrate: 'Migriraj',
      clone: 'Kloniraj',
      moveStorage: 'Premesti na storage…',
      moveScope: 'Premesti u scope…',
      openConsole: 'Otvori konzolu',
      forceStop: 'Prinudno ugasi',
      markTemplate: 'Označi kao šablon',
      unmarkTemplate: 'Konvertuj nazad u VM',
      error: 'Nije moguće izvršiti akciju'
    },
    cordon: {
      confirmTitle: 'Čvor je u održavanju',
      confirmHint:
        'Kordon se ne može spustiti dok je store klastera nedostupan. Potvrdom izjavljujete da to znate: VM se tamo ipak pokreće, a saglasnost ostaje zabeležena na zadatku.',
      confirm: 'Ipak pokreni'
    },
    markTemplate: {
      confirmTitle: 'Označiti {name} kao šablon?',
      confirmBody: 'Konfiguracija se zamrzava i VM više ne može da se upali — može samo da se klonira, ili vrati u VM. Ime, beleške i tagovi ostaju izmenjivi.',
      confirm: 'Označi kao šablon',
      moved: '{name} je sada šablon — premeštena je u tab Šabloni.'
    },
    unmarkTemplate: {
      confirmTitle: 'Konvertovati {name} nazad u VM?',
      confirmBody: 'Šablon ponovo postaje obična VM: izmenjiva i može da se pokrene (sledeće pokretanje je smešta na čvor).',
      confirm: 'Konvertuj nazad u VM',
      moved: '{name} je ponovo virtuelna mašina — premeštena je u tab Virtuelne mašine.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Po oznaci čvora',
      hint: 'tag=vrednost, odvojeno zarezima (u AND kombinaciji): decider bira među odgovarajućim čvorovima',
      invalid: 'Neispravan format — koristite tag=vrednost, odvojeno zarezima',
      resolved: 'Odgovarajući članovi: {nodes}'
    },
    migrate: {
      title: 'Live migracija',
      submit: 'Migriraj',
      target: 'Odredišni čvor',
      auto: 'Automatski (Proximity)',
      hint: 'VM se premešta bez power cyclea. Svaki storage koji dodiruje mora biti deljen; pauzirana VM migrira pauzirana.',
      error: 'Migracija je odbijena'
    },
    moveStorage: {
      title: 'Premestite na storage',
      submit: 'Premesti',
      target: 'Odredišni storage',
      noTargets: 'Nijedan storage ne prima diskove',
      hint: 'Svi diskovi ugašene VM putuju na izabrani storage, jedan po jedan, zadržavajući svoj id — oni koji su već na odredištu se preskaču. Napredak živi na stranici zadataka.',
      error: 'Premeštanje je odbijeno'
    },
    moveScope: {
      title: 'Premestite u scope',
      submit: 'Premesti',
      target: 'Odredišni scope',
      hint: 'VM odmah menja scope — id i diskovi ostaju, njeni owned diskovi je prate, i može ostati upaljena. Trenutno živi u {scope}. Ko je vidi menja se sa scopeom.',
      error: 'Premeštanje u scope je odbijeno'
    },
    start: {
      title: 'Pokrenite VM',
      submit: 'Pokreni',
      target: 'Odredišni čvor',
      auto: 'Automatski (preporučeno)',
      recommended: 'preporučeno',
      hint: 'Izaberite odredišni čvor ili prepustite da Proximity smesti VM birajući među važećim kandidatima. Čvorovi koji ne mogu da je ugoste onemogućeni su uz razlog.',
      error: 'Nije moguće pokrenuti VM'
    },
    console: {
      media: 'CD/DVD uređaji',
      mediaGuestToolsHint: 'Sadrži TVirt Guest Tools — odavde možete da ih izbacite ili uklonite uređaj',
      slotOpsDeferred: 'Na ovom profilu dodavanje i uklanjanje uređaja primenjuju se pri sledećem power cycleu (promene medija su trenutne).',
      mountGuestTools: 'Montiraj TVirt Guest Tools',
      ejectGuestTools: 'Izbaci TVirt Guest Tools',
      bootOrder: 'Redosled pokretanja',
      bootOrderHint: 'Novi redosled se čuva odmah i primenjuje pri sledećem power cycleu — konzolna sesija ostaje povezana.'
    },
    snapshots: {
      create: 'Kreiraj snimak',
      createTitle: 'Kreirajte snimak',
      createSubmit: 'Kreiraj',
      name: 'Ime',
      nameHint: 'Slova, cifre, tačka, crtica, donja crta.',
      consistencyHint: 'Konzistentnost je automatska: guest agent zamrzava filesysteme kada odgovori; u suprotnom se VM nakratko pauzira oko snimka.',
      memory: 'Uključi memoriju',
      memoryHint: 'Hvata živu RAM: vraćanje nastavlja VM u radu. Zahteva da svi diskovi budu qcow2.',
      currentChip: 'Ovde ste',
      revert: 'Vrati',
      revertTitle: 'Vratiti na {name}?',
      revertBody: 'Diskovi se vraćaju na stanje snimka; sve što se desilo posle njega je izgubljeno. Snimak samo diskova zahteva zaustavljenu VM.',
      delete: 'Obriši',
      deleteTitle: 'Obrisati snimak {name}?',
      deleteBody: 'Tačka vraćanja nestaje; sadržaj diskova ostaje netaknut.',
      deleteMergeHint: 'Njegova delta se spaja u {children}: svaka kasnija tačka vraćanja ostaje važeća.',
      deleteDuplication: 'Prihvatam dupliranje',
      deleteDuplicationHint: 'Delta se kopira u svakog od {count} čitalaca (snapshoti deca i, ako je ovaj trenutni, aktivna glava): zauzeti prostor može da raste umesto da se smanjuje.',
      error: 'Operacija nad snimkom je odbijena'
    },
    clone: {
      title: 'Klonirajte VM',
      submit: 'Kloniraj',
      name: 'Ime kopije',
      storage: 'Odredišni storage za diskove',
      sameStorage: 'Isti kao izvor',
      full: 'Puna kopija',
      fullHint: 'Kopira svaki bajt i kida vezu sa izvornim diskovima. Podrazumevani je linked clone: trenutan, ali vezan lancem za izvor (samo qcow2).',
      hint: 'Klon zadržava konfiguraciju i firmware izvora; MAC adrese i TPM identitet su novi.',
      markAs: 'Tip klona',
      markAsInheritVm: 'Kao izvor (VM)',
      markAsInheritTemplate: 'Kao izvor (šablon)',
      markAsVm: 'Virtuelna mašina',
      markAsTemplate: 'Šablon',
      markAsHintVm: 'Izaberite Šablon da biste kopiju unapredili u jednom koraku.',
      markAsHintTemplate: 'Izaberite Virtuelna mašina za deploy iz ovog šablona u jednom koraku.',
      error: 'Kloniranje je odbijeno'
    },
    bulk: {
      selected: 'izabrano',
      deleteTitle: {
        one: 'Obrisati izabrani VM ({count})?',
        few: 'Obrisati izabrane VM-ove ({count})?',
        other: 'Obrisati izabrane VM-ove ({count})?'
      },
      deleteBody: 'Svaka VM prolazi iste provere kao pojedinačno brisanje; odbijanja se prijavljuju po stavci.',
      done: 'prihvaćeno',
      refused: 'odbijeno'
    },
    delete: {
      button: 'Obriši',
      confirmTitle: 'Obrisati {name}?',
      confirmBody: 'Virtuelna mašina i diskovi u njenom vlasništvu biće obrisani. Operacija je nepovratna.',
      keepDisks: 'Zadrži diskove',
      keepDisksHint: 'Diskovi kreirani sa VM ostaju na svom storageu kao samostalni diskovi.',
      confirm: 'Obriši',
      cancel: 'Otkaži',
      error: 'Brisanje nije uspelo',
      blockedPhase: 'Prvo zaustavite VM',
      blockedProtected: 'VM je zaštićena — prvo uklonite zaštitu',
      blockedDeleting: 'Brisanje je već u toku'
    },
    logs: {
      title: 'Logovi',
      subtitle: 'Strukturirani log frejmovi iz zadataka koji diraju ovu VM',
      when: 'Kada',
      task: 'Zadatak',
      level: 'Nivo',
      message: 'Poruka',
      empty: 'Još nema logova',
      loadError: 'Nije moguće učitati logove — da li je TVirt backend dostupan?'
    },
    stop: {
      title: 'Zaustavite virtuelnu mašinu',
      modeGraceful: 'Graceful gašenje',
      modeGracefulHint: 'Od guest operativnog sistema se traži da se prirodno ugasi (ACPI); ako ignoriše zahtev, posle timeouta sledi prinudno gašenje.',
      modeForced: 'Prinudno gašenje',
      modeForcedHint: 'Odmah seče napajanje, kao izvlačenje utikača.',
      timeout: 'Fallback timeout (u sekundama)',
      timeoutHint: 'Koliko dugo čekati guest pre prinudnog gašenja'
    },

    // Il menu del bottone split di creazione (Luca 2026-07-23): "Da zero" apre
    // il wizard, le altre due voci sono stub di roadmap.
    createFromScratch: 'Od nule',
    createFromTemplate: 'Iz šablona',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Izvrši deploy',
      error: 'Deploy nije uspeo',
      compatNote: 'QuickDeploy zahteva šablon kompatibilan sa QuickDeploy: platforma prilagođava gosta (mreža, domen, aktivacija) pri prvom pokretanju.',
      template: 'Šablon',
      noTemplates: 'Nijedan šablon još ne deklariše kompatibilnost sa QuickDeploy — deklarišite je na kartici Šabloni (Linux sa cloud-init, Windows sa cloudbase-init nakon sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Ime hosta',
      hostnameHint: 'Ime hosta ili FQDN; prazno = ime VM (Windows: najviše 15 znakova)',
      ip: 'IP adresa',
      ipHint: 'Host i prefiks, npr. 192.168.122.101/24; prazno = DHCP',
      gateway: 'Gateway',
      dns: 'DNS serveri',
      dnsHint: 'Do tri, odvojeni zarezom',
      count: 'Instance',
      countHint: 'Više od jedne: nazvane <ime>-1…-N, samo DHCP',
      user: 'Korisnik',
      userHint: 'Prazno = podrazumevani korisnik slike (Linux) ili Administrator (Windows)',
      password: 'Lozinka',
      passwordHint: 'Upisuje se u generisani user-data, koji platforma zatim deklariše tajnim: niko ga više ne čita',
      sshKeys: 'Javni SSH ključevi',
      sshKeysHint: 'Jedan po redu (ssh-ed25519 AAAA… komentar)',
      productKey: 'Product key za Windows',
      kmsServer: 'KMS server',
      kmsHint: 'Host ili host:port — zahteva product key (KMS klijentski ključ)',
      adDomain: 'Pridruži domenu Active Directory',
      adDomainHint: 'Prazno = bez pridruživanja domenu',
      adUser: 'Nalog za pridruživanje',
      adPassword: 'Lozinka naloga za pridruživanje',
      adOu: 'Odredišna OU (opciono)',
      advanced: 'Napredno: sirovi dokumenti',
      userData: 'user-data (sirovi)',
      userDataHint: 'Zamenjuje generisani user-data: korisnik, lozinka, ključevi i Windows polja iznad moraju ostati prazni',
      networkConfig: 'network-config (sirovi)',
      networkConfigHint: 'Zamenjuje generisanu mrežu: IP, gateway i DNS iznad moraju ostati prazni',
      secret: 'Tretiraj sirovi user-data kao tajnu',
      secretHint: 'Označen tajnim, API ga više nikome ne vraća i u Checkpoint-u putuje zapečaćen masterpass-om',
      startNow: 'Pokreni odmah',
      startNowHint: 'Svaka instanca se pokreće čim je definisana; seed nastaje pri tom pokretanju'
    },

    create: {
      nicAttachmentNetwork: 'Logička mreža (fabric)',
      nicNetwork: 'Logička mreža',
      nicNetworkHint: 'PREPORUČENI put (F3): vNIC se ostvaruje na IZVEDENOM bridge-u poslužujućeg čvora — bridge se rađa pri eksplicitnom fabric apply-u, a pokretanje na čvoru koji ga još ne nosi odbija govoreći. Kad ode zadnja referenca flote, bridge ispada pri sledećem apply-u.',
      button: 'Kreiraj VM',
      title: 'Kreirajte virtuelnu mašinu',
      dialogTitle: 'Kreirajte virtuelnu mašinu',
      stepGeneral: 'Opšte',
      stepGeneralHint: 'Ime i profil',
      stepCompute: 'CPU i RAM',
      stepComputeHint: 'Topologija i dimenzionisanje',
      stepDisks: 'Diskovi',
      stepDisksHint: 'Kreirajte ili prikačite',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Uređaji i mediji',
      stepNetwork: 'Mreža',
      stepNetworkHint: 'NIC-ovi: trunk ili bridge',
      stepSummary: 'Rezime',
      stepSummaryHint: 'Proverite i kreirajte',
      name: 'Ime',
      nameHint: 'Mala slova, cifre i crtice (DNS-1123)',
      nextButton: 'Dalje',
      prevButton: 'Nazad',
      submitButton: 'Kreiraj',
      creating: 'Kreiranje…',
      sockets: 'Socketi',
      cores: 'Core po socketu',
      threads: 'Thread po coreu',
      totalVcpus: 'Ukupno vCPU',
      memoryGib: 'Memorija (GiB)',
      cpuModelHint: "'host' izlaže CPU hosta",
      cpuLimitHint: 'Limit u host coreovima — prazno = neograničeno',
      cpuNestedHint: "Izlaže vmx/svm gostu da bi mogao da pokreće sopstveni hipervizor — zahteva CPU model host i čvor sa uključenim nested",
      newDisk: 'Novi disk',
      attachDisk: 'Prikači postojeći disk',
      diskStorage: 'Storage',
      diskSize: 'Veličina (GiB)',
      diskSelect: 'Disk',
      addDisk: 'Dodaj disk',
      addCdrom: 'Dodaj CD/DVD uređaj',
      addNic: 'Dodaj mrežni interfejs',
      remove: 'Ukloni',
      slotLimit: 'Dostignut limit slotova',
      cdromImage: 'Slika (prazan uređaj ako je nema)',
      nicAttachment: 'Priključak',
      nicAttachmentTrunk: 'Overlay trunk',
      nicAttachmentBridge: 'Host bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Nijedna (samo tagged)',
      nicTrunkHint: 'Bar jedna strana: untagged overlay i/ili tagged VLAN mapiranja — VM može da radi samo na hostovima koje deklariše svaka referencirana overlay mreža',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay mreža',
      addTagged: 'Dodaj tagged VLAN',
      nicBridge: 'Ime host bridgea',
      nicBridgeHint: 'NM host bridge po imenu — VM može da radi samo na serverima čija host mreža deklariše ovaj bridge',
      nicMac: 'MAC (automatski ako je prazno)',
      noDisksHint: 'Nema diskova: VM će imati samo CD/DVD uređaje koje dodate.',
      noCdromsHint: 'Nema CD/DVD uređaja: dodajte jedan za pokretanje sa ISO slike.',
      mountGuestTools: 'Montiraj TVirt Guest Tools pri prvom pokretanju',
      mountGuestToolsHint: 'Stavlja ISO sa virtio drajverima i guest agentom u prazan CD uređaj (dodat po potrebi) — Windows instaleru su potrebni da bi video svoje diskove.',
      noNicsHint: 'Nema mrežnih interfejsa: VM će se pokrenuti bez povezivosti.',
      taggedMappings: 'Tagged VLAN mapiranja',
      summaryDevices: 'Uređaji',
      bootOrderTitle: 'Redosled pokretanja',
      bootOrderHint: 'Prevucite da promenite redosled — pobeđuje prvi uređaj sa kog se može pokrenuti; NIC-ovi pokreću PXE',
      bootOrderUp: 'Pomeri naviše',
      bootOrderDown: 'Pomeri naniže',
      createError: 'Kreiranje nije uspelo'
    },
    edit: {
      button: 'Izmeni',
      title: 'Izmenite virtuelnu mašinu',
      cancel: 'Otkaži',
      save: 'Sačuvaj',
      error: 'Izmena nije uspela',
      modelStoppedOnly: 'Izmenjivo samo dok je VM ugašena',
      firmwareStoppedOnly: 'Firmware je izmenjiv samo dok je VM ugašena — pri sledećem pokretanju mašina kreće sa novim firmwareom, a UEFI varijable ostaju',
      hugePagesStoppedOnly: 'Izmenjivo samo dok je VM ugašena — pri sledećem pokretanju memorija nastaje na novom backingu',
      runningHint: 'Izmene se primenjuju pri sledećem power cycleu',
      sectionCpu: 'CPU',
      sectionMemory: 'Memorija',
      sectionPolicy: 'Politike'
    },
    devices: {
      networkChip: 'fabric mreža',
      title: 'Uređaji',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Dodaj USB uređaj',
      addUsbTitle: 'Zahtevajte klasu USB uređaja',
      usbClassHint:
        'VM traži KLASU USB uređaja (vrednost taga usb-device), nikad pojedinačan uređaj: pri pokretanju se bira i rezerviše konkretan slobodan uređaj na izabranom čvoru. Tagujte registrovane uređaje u Klaster › USB i PCIe resursi.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Vrednost klase',
      noUsbTags: 'Još nema usb-device tagova — kreirajte jedan i tagujte registrovane uređaje u Klaster › USB i PCIe resursi.',
      noUsbValues: 'Ovaj tag još nema deklarisane vrednosti.',
      usbEmpty: 'Nema USB zahteva — dodajte klasu da bi uređaj bio propušten pri pokretanju.',
      usbClassChip: 'klasa',
      usbPortChip: 'port',
      usbUnclaimed: 'Nijedan uređaj nije rezervisan — rešava se pri pokretanju VM.',
      addGpu: 'Dodaj GPU',
      addGpuTitle: 'Zahtevajte klasu GPU',
      gpuClassHint:
        'VM traži KLASU GPU (vrednost taga gpu-device), nikad konkretnu karticu: pri pokretanju se konkretna slobodna kartica bira i rezerviše na izabranom čvoru, i njena CELA IOMMU grupa prolazi zajedno. Tagujte registrovane GPU u Klaster › USB i PCIe resursi.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Vrednost klase',
      noGpuTags: 'Još nema gpu-device tagova — kreirajte jedan i tagujte registrovane GPU u Klaster › USB i PCIe resursi.',
      noGpuValues: 'Ovaj tag još nema deklarisane vrednosti.',
      gpuEmpty: 'Nema GPU zahteva — dodajte klasu da bi kartica bila propuštena pri pokretanju.',
      gpuClassChip: 'klasa',
      gpuGroupChip: 'IOMMU grupa ×',
      gpuUnclaimed: 'Nijedna kartica nije rezervisana — rešava se pri pokretanju VM.',
      gpuPowerCycle: 'Nema GPU hotpluga — izmene važe od sledećeg power cyclea (PendingRestart)',
      actions: 'Akcije',
      attachDisk: 'Dodaj disk',
      attachDiskTitle: 'Dodajte disk',
      attach: 'Prikači',
      noFreeDisks: 'Nema nekorišćenih diskova — kreirajte jedan u Virtuelne mašine › Nekorišćeni diskovi.',
      addCdrom: 'Dodaj uređaj',
      addCdromTitle: 'Dodajte CD/DVD uređaj',
      editCdromTitle: 'Promenite CD/DVD sliku',
      changeMedia: 'Promeni CD/DVD sliku',
      ejectMedium: 'Izbaci',
      mountGuestTools: 'Montiraj TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools montirane',
      guestToolsClickMount: 'Stavlja TVirt Guest Tools ISO u prvi prazan CD/DVD uređaj',
      guestToolsClickUnmount: 'Kliknite za izbacivanje — uređaj ostaje, prazan',
      guestToolsNoSlot: 'Nema praznog CD/DVD uređaja — dodajte uređaj (ili izbacite medij) da biste montirali TVirt Guest Tools',
      guestToolsSkew: 'Montirano v{pinned}; čvor {node} sada služi v{current}: izbaci i ponovo montiraj da ažuriraš',
      ejectGuestTools: 'Izbaci TVirt Guest Tools (uređaj ostaje, prazan)',
      guestToolsEjectConfirmTitle: 'Izbaciti TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Medij se izbacuje iz upaljene VM — CD/DVD uređaj ostaje, prazan.',
      applyLive: 'Primeni odmah (VM je upaljena)',
      addNic: 'Dodaj interfejs',
      addNicTitle: 'Dodajte mrežni interfejs',
      editNicTitle: 'Izmenite mrežni interfejs',
      bridgeChip: 'bridge',
      cable: 'Virtuelni kabl',
      plug: 'Prikači virtuelni kabl',
      unplug: 'Otkači virtuelni kabl',
      remove: 'Ukloni',
      removeTitle: 'Ukloniti {device}?',
      removeBody: 'Na upaljenoj VM izmena se primenjuje pri sledećem power cycleu. Diskovi i slike se otkačinju, nikad ne brišu.'
    }
  }
}
